import React, {useContext, useEffect, useState} from 'react';
import {
    Badge,
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Typography,
    useToastProvider
} from '@deere/fuel-react';
import {useHistory, useParams} from 'react-router-dom';
import {useStyles} from "../shared/styles/Summary";
import {
    dateInPastOrPresent,
    dateUntil,
    filterRoles,
    filterStakeholders,
    filterUnits,
    toCapitalizeSplitStr
} from '../shared/utils';
import {useAuthConfig} from "../shared/helper";
import {useOktaAuth} from '@okta/okta-react';
import {SUMMARY_FORM_STATE} from "../shared/Constants";
import {Loading} from "../shared/Loading";
import {useForm} from "react-hook-form";
import {SendReminderModal} from "../shared/modal/SendReminderModal";
import Accordion from "@material-ui/core/Accordion";
import {SummaryGeneralCommentsDetails} from "./SummaryGeneralCommentsDetails";
import {SummaryGeneralComments} from './SummaryGeneralComments';
import {ModalDialog} from "../shared/ModalDialog";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import {SummaryDeclineComments} from "./SummaryDeclineComments";
import SummarySelectDropdown from './SummarySelectDropdown';

import {SummaryCriteriaList} from "./SummaryCriteriaList";
import {ManageStakeholdersModal} from "../shared/modal/ManageStakeholdersModal"
import * as PropTypes from "prop-types";
import {UserContext} from "./Main";
import {CampaignDueDateModal} from "./CampaignDueDateModal";
import {FeedbackWindowModal} from "../shared/modal/FeedbackWindowModal";
import {FileCopy} from "@material-ui/icons";
import Stack from "@mui/material/Stack";

export const Summary = ({name}) => {
    const classes = useStyles();
    let history = useHistory();
    const {authState} = useOktaAuth();
    const {enqueueToast} = useToastProvider();
    let authAxios = useAuthConfig();
    let {editCampaignId} = useParams();
    const info = useContext(UserContext);
    const loggedInUserId = info && info.userId;
    const isCriteriaAdmin = info && info.isCriteriaAdmin;
    const [state, setState] = useState(SUMMARY_FORM_STATE);
    const [isLoading, setIsLoading] = useState(false);
    const [expanded, setExpanded] = React.useState('panel1');
    const {control} = useForm();
    const [units, setUnits] = useState([]);
    const [stakeholderType, setStakeholderType] = useState([]);
    const [stakeholderName, setStakeholderName] = useState([]);
    const [selectedUnits, setSelectedUnits] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [selectedStakeholderNames, setSelectedStakeholderNames] = useState([]);
    const [selectedQualitySubcategory, setSelectedQualitySubcategory] = useState([]);
    const [selectedDeliverySubcategory, setSelectedDeliverySubcategory] = useState([]);
    const [selectedProcessAlignmentSubcategory, setSelectedProcessAlignmentSubcategory] = useState([]);
    const [selectedRelationshipSubcategory, setSelectedRelationshipSubcategory] = useState([]);
    const [selectedValueCreationSubcategory, setSelectedValueCreationSubcategory] = useState([]);
    const [selectedSubcategory, setSelectedSubcategory] = useState([]);
    const [subcategory, setSubcategory] = useState([]);
    const [newDueDate, setNewDueDate] = useState();
    const [currentFiscalYear, setCurrentFiscalYear] = useState();
    const [currentFiscalPeriod, setCurrentFiscalPeriod] = useState();

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const handleBack = () => {
        history.push("/campaigns");
    }

    const handleDuplicateCampaign = () => {
        authAxios.post(`/campaign/duplicate/${editCampaignId}`)
            .then(res => {
                history.push(`/campaigns/edit-campaign/${res.data.duplicateCampaignId}`);
            }).catch((error) => {
            console.log(error);
        });
    }

    const handleSendReminder = () => {
        authAxios.post(`/campaign/reminder/${editCampaignId}`)
            .then(res => {
                console.log(res.data)
                enqueueToast({
                    variant: "success",
                    title: "Reminder email sent",
                    isCloseable: true
                });
            }).catch((error) => {
            console.log(error);
            enqueueToast({
                variant: "error",
                title: "System Error",
                isPersistent: true
            });
        });
    }

    const handleDueDateChange = () => {
        setIsLoading(true)
        const localDate = `${String(newDueDate.getMonth() + 1).padStart(2, '0')}/${String(newDueDate.getDate()).padStart(2, '0')}/${newDueDate.getFullYear()}`
        authAxios.put(`/campaign/${editCampaignId}/duedate?newDueDate=${localDate}`)
            .then(updateDueDateRes => {
                getCampaignData(editCampaignId).then(updatedCampaignRes => {
                    processData(updatedCampaignRes.data)
                    setIsLoading(false)
                    enqueueToast({
                        variant: "success",
                        title: "Success",
                        message: updateDueDateRes.data,
                        isCloseable: true
                    });
                }).catch(() => setIsLoading(false))
            }).catch((error) => {
            console.log(error.response.status);
            setIsLoading(false)
            enqueueToast({
                variant: "error",
                title: "Error updating end date: " + error.response.data[error.response.status] || "System Error",
                isPersistent: true
            });
        });
    }

    const getCampaignData = async (id) => {
        return await authAxios.get(`campaign/summary/${id}`);
    }

    const getUnits = async (id) => {
        return await authAxios.get(`campaign/${id}/units`);
    }

    const getStakeholderType = async (id) => {
        return await authAxios.get(`campaign/${id}/stakeholder-types`);
    }

    const getStakeholderName = async (id) => {
        return await authAxios.get(`campaign/${id}/stakeholder-names`);
    }

    const getSubcategory = async (id) => {
        return await authAxios.get(`campaign/summary/${id}`);
    }

    const getCurrentCalendar = async () => {
        try {
            return await authAxios.get(`/calendar/current`);
        } catch (e) {
            console.error(e);
        }
    };

    const handleManageStakeholders = async (data) => {
        await authAxios.put(`/campaign/manage/${editCampaignId}`, data)
            .then(res => {
                enqueueToast({
                    variant: "success",
                    title: "Campaign stakeholders updated successfully",
                    isCloseable: true
                });
                getCampaignData(editCampaignId).then(res => {
                    const data = res.data;
                    processData(data)
                })
            }).catch((error) => {
                enqueueToast({
                    variant: "error",
                    title: "System Error",
                    message: error.response ? error.response.data[error.response.status] : "",
                    isPersistent: true
                });
                console.log(error);
            });
    }

    const handleChangeFeedbackWindow = async () => {
        setIsLoading(true);
        try {
            await authAxios.patch(`/campaign/${editCampaignId}/feedback-window?newStatus=${!state.feedbackOpen}`)
            getCampaignData(editCampaignId).then(res => {
                const data = res.data;
                processData(data)
                setIsLoading(false)
                enqueueToast({
                    variant: 'success',
                    title: 'Success',
                    message: `Feedback window has been updated successfully.`
                })
            })
        } catch (e) {
            console.error(e);
            setIsLoading(false)
            enqueueToast({
                variant: 'error',
                title: 'Error',
                message: 'An error occurred while changing the feedback window status.'
            })
        }
    }

    const processData = data => {
        setState({
            ...state,
            title: data.title,
            campaignId: data.campaignId,
            supplierName: data.supplierName,
            supplierNumber: data.supplierNumber,
            period: data.period,
            fiscalYear: data.fiscalYear,
            dueDate: data.dueDate,
            daysPending: dateInPastOrPresent(data.dueDate) ? -1 : dateUntil(data.dueDate),
            requestedByName: data.requestedByName,
            requestedById: data.requestedById,
            reminders: data.reminders,
            responses: data.responses,
            generalComments: data.generalComments,
            qualityCriteriaData: data.criteria.filter(item => item.category.id === 1),
            deliverCriteriaData: data.criteria.filter(item => item.category.id === 2),
            processAlignmentCriteriaData: data.criteria.filter(item => item.category.id === 3),
            relationshipCriteriaData: data.criteria.filter(item => item.category.id === 4),
            valueCreationCriteriaData: data.criteria.filter(item => item.category.id === 5),
            criteriaData: data.criteria,
            declinedResponses: data.declinedResponses,
            createdBy: data.createdBy,
            isFeedbackPresent: data.isFeedbackPresent,
            feedbackOpen: data.feedbackOpen
        });
    }

    const processSubcategoryData = data => {
        const qualityCriteriaData = data.criteria.filter(item => item.category.id === 1)
        const deliverCriteriaData = data.criteria.filter(item => item.category.id === 2)
        const processAlignmentCriteriaData = data.criteria.filter(item => item.category.id === 3)
        const relationshipCriteriaData = data.criteria.filter(item => item.category.id === 4)
        const valueCreationCriteriaData = data.criteria.filter(item => item.category.id === 5)
        const qualityCriteriaSubcategory = qualityCriteriaData.map(item => item.subCategory ? item.subCategory : {
            id: null,
            description: 'Not Selected'
        });
        const deliverCriteriaSubcategory = deliverCriteriaData.map(item => item.subCategory ? item.subCategory : {
            id: null,
            description: 'Not Selected'
        });
        const processAlignmentCriteriaSubcategory = processAlignmentCriteriaData.map(item => item.subCategory ? item.subCategory : {
            id: null,
            description: 'Not Selected'
        });
        const relationshipCriteriaSubcategory = relationshipCriteriaData.map(item => item.subCategory ? item.subCategory : {
            id: null,
            description: 'Not Selected'
        });
        const valueCreationCriteriaSubcategory = valueCreationCriteriaData.map(item => item.subCategory ? item.subCategory : {
            id: null,
            description: 'Not Selected'
        });
        const key = 'id';
        setSelectedQualitySubcategory([...new Map(qualityCriteriaSubcategory.map(item => [item[key], item])).values()])
        setSelectedDeliverySubcategory([...new Map(deliverCriteriaSubcategory.map(item => [item[key], item])).values()])
        setSelectedProcessAlignmentSubcategory([...new Map(processAlignmentCriteriaSubcategory.map(item => [item[key], item])).values()])
        setSelectedRelationshipSubcategory([...new Map(relationshipCriteriaSubcategory.map(item => [item[key], item])).values()])
        setSelectedValueCreationSubcategory([...new Map(valueCreationCriteriaSubcategory.map(item => [item[key], item])).values()])

        //TO set for page load
        setSubcategory([...new Map(qualityCriteriaSubcategory.map(item => [item[key], item])).values()])
        setSelectedSubcategory([...new Map(qualityCriteriaSubcategory.map(item => [item[key], item])).values()]);
    }

    const handleValues = (value, type) => {
        if (type === "units") {
            setSelectedUnits(value);
        }
        if (type === "roles") {
            setSelectedRoles(value);
        }
        if (type === "sName") {
            setSelectedStakeholderNames(value);
        }
        if (type === "subCategory") {
            setSelectedSubcategory(value);
        }
    }

    const filterSummaryList = (items) => {
        return items && items.filter(item => {
            const tempUnits = filterUnits(item.feedbacks, selectedUnits)
            const tempRoles = filterRoles(item.feedbacks, selectedRoles)
            const tempStakeholderNames = filterStakeholders(item.feedbacks, selectedStakeholderNames)
            const selectedSubcategoryFilterData = selectedSubcategory.map((subCategory) => subCategory.id)
            return tempUnits.length > 0 &&
                tempRoles.length > 0 &&
                tempStakeholderNames.length > 0 &&
                selectedSubcategoryFilterData.includes(item.subCategory && item.subCategory.id)
        })
    }

    const selectQualitySubcategory = () => {
        setSubcategory(selectedQualitySubcategory);
        setSelectedSubcategory(selectedQualitySubcategory);
    }
    const selectDeliverySubcategory = () => {
        setSubcategory(selectedDeliverySubcategory);
        setSelectedSubcategory(selectedDeliverySubcategory);
    }
    const selectProcessAlignmentSubcategory = () => {
        setSubcategory(selectedProcessAlignmentSubcategory);
        setSelectedSubcategory(selectedProcessAlignmentSubcategory);
    }
    const selectRelationshipSubcategory = () => {
        setSubcategory(selectedRelationshipSubcategory);
        setSelectedSubcategory(selectedRelationshipSubcategory);
    }
    const selectValueCreationSubcategory = () => {
        setSubcategory(selectedValueCreationSubcategory);
        setSelectedSubcategory(selectedValueCreationSubcategory);
    }

    const onDelete = async () => {
        await authAxios.delete(`/campaign/${editCampaignId}`)
            .then(res => {
                enqueueToast({
                    variant: "success",
                    title: "Campaign Deleted Successfully",
                    isCloseable: true
                });
                setTimeout(() => {
                    history.replace(`/campaigns`);
                }, 2000);
            }).catch((error) => {
                enqueueToast({
                    variant: "error",
                    title: "System Error",
                    isPersistent: true
                });
                console.log(error);
            });
    }

    useEffect(() => {
        if (editCampaignId) {
            setIsLoading(true)
            getCurrentCalendar().then(res => {
                setCurrentFiscalYear(res.data.currentFiscalYear);
                setCurrentFiscalPeriod(res.data.currentPeriod);
            });
            getCampaignData(editCampaignId).then(res => {
                const data = res.data;
                processData(data)
                setIsLoading(false)
            })
                .catch((error) => {
                    setIsLoading(false)
                })
            getUnits(editCampaignId).then(res => {
                setUnits(res.data);
                setSelectedUnits(res.data)
            })
            getStakeholderType(editCampaignId).then(res => {
                setStakeholderType(res.data);
                setSelectedRoles(res.data)
            })
            getStakeholderName(editCampaignId).then(res => {
                setStakeholderName(res.data);
                setSelectedStakeholderNames(res.data)
            })
            getSubcategory(editCampaignId).then(res => {
                processSubcategoryData(res.data);
            })
        }
        return () => {
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);

    return (
        <>
            {isLoading && (
                <Loading/>
            )}
            {!isLoading && (
                <Grid container>
                    <Grid item xs={12} className="sticky-header">
                        <Typography variant="h1" component="h1">
                            {state.title ? state.title : `${toCapitalizeSplitStr(state.supplierName)} - ${parseInt(state.supplierNumber)}`}
                        </Typography>
                        <Typography variant="h4">
                            {state.fiscalYear ? `FY${state.fiscalYear}, ${state.period.description}` : ''}
                        </Typography>
                        <Badge variant={state.feedbackOpen ? "success" : "error"}>{state.feedbackOpen ? "Accepting Feedback" : "Feedback Closed"}</Badge>
                    </Grid>
                    <Grid item xs={12} className="sticky-header">
                        <Box display="flex" justifyContent="flex-end" alignItems="center">
                            {(editCampaignId && (isCriteriaAdmin || (loggedInUserId && loggedInUserId?.toUpperCase() === state.createdBy))) && (
                                <ModalDialog
                                    titleText={"Delete Campaign"}
                                    content={state.isFeedbackPresent ?
                                        <React.Fragment>Deleting the campaign will delete all the data,
                                            including feedback that may have already been provided by
                                            stakeholders. <br/> <br/>
                                            Are you sure you want to delete this campaign and all corresponding data?
                                        </React.Fragment> : <React.Fragment>Are you sure you want to delete this
                                            Campaign?</React.Fragment>}
                                    saveButtonText={"Delete"}
                                    onSave={onDelete}
                                    page={"Campaign"}
                                />
                            )}
                            <Button variant="text" onClick={handleDuplicateCampaign} startIcon={<FileCopy />}>
                                Duplicate campaign
                            </Button>
                            {(state.fiscalYear === currentFiscalYear && state.period?.id === currentFiscalPeriod) && (isCriteriaAdmin || loggedInUserId?.toUpperCase() === state.createdBy) && (
                                <Stack direction="row" spacing={2}>
                                    <ManageStakeholdersModal campaignId={editCampaignId} onSave={handleManageStakeholders}/>
                                    <FeedbackWindowModal onSave={handleChangeFeedbackWindow} feedbackOpen={state.feedbackOpen} remainingUsers={state.reminders.map(r => r.user).filter(u => u.userStatus === "ACTIVE")} />
                                </Stack>
                            )}
                            <Button variant="secondary" size="large"
                                    onClick={() => handleBack()}
                            >Back</Button>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box mt={4} mb={4} ml={2} mr={2}>
                            <Card>
                                <CardContent style={{padding: 0}}>
                                    <Box p={4}>
                                        <Grid container alignItems="center" spacing={4}>
                                            <Grid item xs={12} md={10}>
                                                <Box display={"flex"} alignItems={"baseline"}>
                                                <Typography size="lg" fontWeight="bold" display="inline"
                                                            style={{color: "#367c2b"}}>
                                                    {state.responses && state.responses} Responded To-Date
                                                </Typography>
                                                {state.daysPending === -1 ? (
                                                    <Typography color="secondary" display="inline" size="md"
                                                                component="p"
                                                                gutterBottom>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Past Due ({state.dueDate})
                                                    </Typography>
                                                ) : (
                                                    <Typography color="secondary" display="inline" size="md"
                                                                component="p"
                                                                gutterBottom>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {state.daysPending} {state.daysPending === 1 ? 'day' : 'days'} until
                                                        responses are due ({state.dueDate})
                                                    </Typography>
                                                )}
                                                {(isCriteriaAdmin || loggedInUserId?.toUpperCase() === state.createdBy) &&
                                                    <CampaignDueDateModal setNewDueDate={setNewDueDate} handleSave={handleDueDateChange} />
                                                }
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Box display="flex" justifyContent="flex-end">
                                                    {state.reminders && state.reminders.length > 0 && (
                                                        <SendReminderModal campaignId={editCampaignId}
                                                                           onSave={handleSendReminder}/>
                                                    )}
                                                </Box>
                                            </Grid>
                                            {state.declinedResponses && state.declinedResponses.length > 0 ?
                                                <Grid item xs={12}>
                                                    <CardContent style={{padding: 0}}>
                                                        <div className={classes.root}>
                                                            <Accordion expanded={expanded === 'declinePanel'}
                                                                       onChange={handleChange('declinePanel')}>
                                                                <AccordionSummary
                                                                    className={classes.declineSummary}
                                                                    classes={{
                                                                        expandIcon: classes.declineExpand,
                                                                        content: classes.declineContent,
                                                                        expanded: classes.expanded
                                                                    }}
                                                                    expandIcon={<ExpandMoreIcon
                                                                        style={{fontSize: '2rem'}}/>}
                                                                    aria-controls="decline-content"
                                                                    id="decline-header"
                                                                >
                                                                    <Grid container>
                                                                        <Grid item xs={12}>
                                                                            <Typography color="primary"
                                                                                        size="md">{state.declinedResponses && state.declinedResponses.length} Declined
                                                                                Request</Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </AccordionSummary>
                                                                <SummaryDeclineComments
                                                                    classes={classes}
                                                                    details={state.declinedResponses}/>
                                                            </Accordion>
                                                        </div>
                                                    </CardContent>
                                                </Grid> : ""
                                            }
                                        </Grid>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box m={2}>
                            <Tabs>
                                <Card>
                                    <CardContent style={{padding: 0}}>
                                        <TabList aria-label="category tabs">
                                            <Tab label="Quality" onClick={selectQualitySubcategory}/>
                                            <Tab label="Delivery" onClick={selectDeliverySubcategory}/>
                                            <Tab label="Process Alignment" onClick={selectProcessAlignmentSubcategory}/>
                                            <Tab label="Relationship" onClick={selectRelationshipSubcategory}/>
                                            <Tab label="Value Creation" onClick={selectValueCreationSubcategory}/>
                                        </TabList>
                                    </CardContent>
                                </Card>
                                <Grid container spacing={4} p={4}>
                                    <Grid item xs={3} style={{marginTop: "10px"}}>
                                        <SummarySelectDropdown
                                            name={"subcategory"}
                                            label={"Sub Category"}
                                            onOptionsChange={handleValues}
                                            options={subcategory}
                                            control={control}
                                            autocompleteValues={selectedSubcategory}
                                            noShowTag={subcategory.length === selectedSubcategory.length}
                                            type="subCategory"/>
                                    </Grid>
                                    <Grid item xs={3} style={{marginTop: "10px"}}>
                                        <SummarySelectDropdown
                                            name={"units"}
                                            label={"All Units"}
                                            onOptionsChange={handleValues}
                                            options={units}
                                            control={control}
                                            autocompleteValues={selectedUnits}
                                            noShowTag={units.length === selectedUnits.length}
                                            type="units"/>
                                    </Grid>
                                    <Grid item xs={3} style={{marginTop: "10px"}}>
                                        <SummarySelectDropdown
                                            name={"stakeholderType"}
                                            label={"All Stakeholder Types"}
                                            onOptionsChange={handleValues}
                                            options={stakeholderType}
                                            control={control}
                                            autocompleteValues={selectedRoles}
                                            noShowTag={stakeholderType.length === selectedRoles.length}
                                            type="roles"/>

                                    </Grid>
                                    <Grid item xs={3} style={{marginTop: "10px"}}>
                                        <SummarySelectDropdown
                                            name={"stakeholderName"}
                                            label={"Stakeholder Names"}
                                            onOptionsChange={handleValues}
                                            options={stakeholderName}
                                            control={control}
                                            autocompleteValues={selectedStakeholderNames}
                                            noShowTag={stakeholderName.length === selectedStakeholderNames.length}
                                            type="sName"/>
                                    </Grid>
                                </Grid>
                                <Box>
                                    <TabPanels>
                                        <TabPanel>
                                            <>
                                                <SummaryCriteriaList
                                                    data={filterSummaryList(state.qualityCriteriaData)}
                                                    units={selectedUnits}
                                                    roles={selectedRoles}
                                                    names={selectedStakeholderNames}
                                                    subCategory={selectedSubcategory}/>
                                            </>
                                            <CardContent style={{padding: 0, marginTop: 10}}>
                                                <div className={classes.root}>
                                                    <Accordion expanded={expanded === 'panel11'}
                                                               onChange={handleChange('panel11')}>
                                                        <SummaryGeneralComments classes={classes}/>
                                                        <SummaryGeneralCommentsDetails
                                                            classes={classes}
                                                            details={state.generalComments}
                                                            category={"1"}/>
                                                    </Accordion>
                                                </div>
                                            </CardContent>
                                        </TabPanel>
                                        <TabPanel>
                                            <SummaryCriteriaList data={filterSummaryList(state.deliverCriteriaData)}
                                                                 units={selectedUnits}
                                                                 roles={selectedRoles}
                                                                 names={selectedStakeholderNames}
                                                                 subCategory={selectedSubcategory}/>
                                            <CardContent style={{padding: 0, marginTop: 10}}>
                                                <div className={classes.root}>
                                                    <Accordion expanded={expanded === 'panel2'}
                                                               onChange={handleChange('panel2')}>
                                                        <SummaryGeneralComments classes={classes}/>
                                                        <SummaryGeneralCommentsDetails
                                                            classes={classes}
                                                            details={state.generalComments}
                                                            category={"2"}/>
                                                    </Accordion>
                                                </div>
                                            </CardContent>
                                        </TabPanel>
                                        <TabPanel>
                                            <SummaryCriteriaList
                                                data={filterSummaryList(state.processAlignmentCriteriaData)}
                                                units={selectedUnits}
                                                roles={selectedRoles}
                                                names={selectedStakeholderNames}
                                                subCategory={selectedSubcategory}/>
                                            <CardContent style={{padding: 0, marginTop: 10}}>
                                                <div className={classes.root}>
                                                    <Accordion expanded={expanded === 'panel3'}
                                                               onChange={handleChange('panel3')}>
                                                        <SummaryGeneralComments classes={classes}/>
                                                        <SummaryGeneralCommentsDetails
                                                            classes={classes}
                                                            details={state.generalComments}
                                                            category={"3"}/>
                                                    </Accordion>
                                                </div>
                                            </CardContent>
                                        </TabPanel>
                                        <TabPanel>
                                            <SummaryCriteriaList
                                                data={filterSummaryList(state.relationshipCriteriaData)}
                                                units={selectedUnits}
                                                roles={selectedRoles}
                                                names={selectedStakeholderNames}
                                                subCategory={selectedSubcategory}/>
                                            <CardContent style={{padding: 0, marginTop: 10}}>
                                                <div className={classes.root}>
                                                    <Accordion expanded={expanded === 'panel4'}
                                                               onChange={handleChange('panel4')}>
                                                        <SummaryGeneralComments classes={classes}/>
                                                        <SummaryGeneralCommentsDetails
                                                            classes={classes}
                                                            details={state.generalComments}
                                                            category={"4"}/>
                                                    </Accordion>
                                                </div>
                                            </CardContent>
                                        </TabPanel>
                                        <TabPanel>
                                            <SummaryCriteriaList
                                                data={filterSummaryList(state.valueCreationCriteriaData)}
                                                units={selectedUnits}
                                                roles={selectedRoles}
                                                names={selectedStakeholderNames}
                                                subCategory={selectedSubcategory}/>
                                            <CardContent style={{padding: 0, marginTop: 10}}>
                                                <div className={classes.root}>
                                                    <Accordion expanded={expanded === 'panel5'}
                                                               onChange={handleChange('panel5')}>
                                                        <SummaryGeneralComments classes={classes}/>
                                                        <SummaryGeneralCommentsDetails
                                                            classes={classes}
                                                            details={state.generalComments}
                                                            category={"5"}/>
                                                    </Accordion>
                                                </div>
                                            </CardContent>
                                        </TabPanel>
                                    </TabPanels>
                                </Box>
                            </Tabs>
                        </Box>
                    </Grid>
                </Grid>
            )}
        </>
    );
}

Summary.propTypes = {
    name: PropTypes.string
}
